/**
 * @author vishwadeep.kapoor
 * @Date: 2018-12-19 11:16:16
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2018-12-19 13:22:13
 */

import * as reqHandler from '../../config/services/serviceHandler';
import endpoint from '../../config/endPoints';
// import axios from 'axios';
import { DEFAULT_ACTION, FETCH_RESTAURANT_SUCCESS, SET_RESTURANT_DEAL_SUCCESS, SET_RESTURANT_DEAL_FORM } from './constants';
import { rootApiResponse, clearDefaultError } from '../HeaderContainer/actions';
import { utils, eventTracking } from '../../devUtils';
// import { utils, constants } from '../../devUtils';


// const defaultAction = () => ({ type: DEFAULT_ACTION });
const successFetchResturantAction = (payload) => ({ type: FETCH_RESTAURANT_SUCCESS, payload });
export const successBookResturantDeal = (payload) => ({ type: SET_RESTURANT_DEAL_SUCCESS, payload });

export const fetchResturantDetails = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(clearDefaultError());
    const { merchant_data } = await reqHandler.postHandler(api, endpoint.POST_RESTURANT_DATA, payload);
    dispatch(successFetchResturantAction(merchant_data));
  } catch (err) {
    // dispatch(rootApiResponse({ api: 'FETCH_Resturant', reason: err, success: false }));
    dispatch(rootApiResponse(utils.errorResponse('FETCH_Resturant', err)));
  }
};

export const bookResturantDeal = (payload, isLoggedIn) => async (dispatch, getState, api) => {
  try {
    const API_ENDPOINT = isLoggedIn ? endpoint.POST_RESTURANT_DEAL : endpoint.POST_RESTURANT_BOOKING;
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const response = await reqHandler.postHandler(api, API_ENDPOINT, payload);
    // const response = await {"result":"We have received your request. We shall get in touch with you very soon! (Sit back until then!)","status":1,"data":{"transactionid":"20181126744E5","deal":"10% Discount on Ala carte Bill","numberofpeople":"1","phone_number":"7503726967","user_name":"testing","location":"Biryani Bowl, Gachibowli","restaurant_name":"90, Padma Sri Gardens Layout, Gachibowli,Hyderabad"}};
    const { result, data } = response;
    if (result && data) {
      dispatch(utils.isReducerLoading(DEFAULT_ACTION));
      dispatch(successBookResturantDeal(response));
      window.gtag_report_conversion();
      eventTracking.triggerEvent('Restaurant Deals', 'Confirm Booking', 'Success'); // for google analytics event tracking
    } else {
      throw (result);
    }
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    dispatch(rootApiResponse(utils.errorResponse('DEAL_BOOKING', err)));
    eventTracking.triggerEvent('Restaurant Deals', 'Confirm Booking', 'Success'); // for google analytics event tracking
  }
};

export const changeDealBookDetails = (payload) => ({ type: SET_RESTURANT_DEAL_FORM, payload });



// WEBPACK FOOTER //
// client/containers/RestaurantDetails/actions.js